import * as React from 'react';

import { Box } from '@rbilabs/universal-components';
import { useRouter } from 'expo-router';

import { CardModal } from 'components/card-modal';
import { useRoute } from 'hooks/navigation/use-route';
import { t } from 'state/intl/translations';
import { useLoyaltyClaimPointsContext } from 'state/loyalty-claim-points';

import {
  EarnedPointsText,
  EarnedPointsWrapper,
  StyledLoyaltyPointsIcon,
} from './loyalty-claim-points.styled';
import LoyaltyClaimPointsView from './loyalty-claim-points.view';
import SuccessAnimation from './success-animation';

const LoyaltyClaimPointsAccepted = () => {
  const { data } = useLoyaltyClaimPointsContext();
  const { navigate } = useRouter();
  const { params } = useRoute<{ earnedPoints?: number }>();

  const handleOnPress = (path?: string | null) => navigate(path || '/');

  const content = data?.claimPointsSuccessfulSubmissionScreenContent;

  const earnedPoints = params.earnedPoints;

  return (
    <CardModal alwaysShowHeader>
      <Box position="absolute">
        <SuccessAnimation />
      </Box>
      <LoyaltyClaimPointsView
        content={content}
        onPress={handleOnPress}
        bottomButtonConfig={{
          asLink: true,
        }}
      >
        {!!earnedPoints && (
          <EarnedPointsWrapper>
            {t('earned')}
            <StyledLoyaltyPointsIcon />
            <EarnedPointsText>{earnedPoints}</EarnedPointsText>
          </EarnedPointsWrapper>
        )}
      </LoyaltyClaimPointsView>
    </CardModal>
  );
};

export default LoyaltyClaimPointsAccepted;
